<template>
    <c-dialog ref="dialog" mode="slide" width="70vw" :button="false">
        <div class="m-log-content">
            <div class="m-log-head">
                <span v-if="orderNo">{{orderNo}}</span>
                <span v-if="customerName" class="m-log-code">客户：{{customerName}}</span>
                <span v-if="productName" class="m-log-code">商品：{{productName}}</span>
            </div>
            <c-title>还款审批记录</c-title>
            <c-table ref="list" border :paging="false">
                <c-table-column label="还款单号" width="140">
                    <template #default="{data}">
                        <c-link color="blue" @click="creditRepaymentDetail(data)">{{data.record_no}}</c-link>
                    </template>
                </c-table-column>
                <c-table-column label="还款单金额" width="110">
                    <template #default="{data}">
                        {{formatPrice(data.repayment_amount)}}
                    </template>
                </c-table-column>
                <c-table-column label="账单数" name="order_count" width="70"></c-table-column>
                <c-table-column label="审批状态" width="90">
                    <template #default="{data}">
                        <c-state async dict="AUDIT_STATE" tag :value="data.state"></c-state>
                    </template>
                </c-table-column>
                <c-table-column label="提交人" width="90">
                    <template #default="{data}">
                        {{data.create_user_realname || '-'}}
                    </template>
                </c-table-column>
                <c-table-column label="提交时间" name="create_date" width="140"></c-table-column>
                <c-table-column label="审批人" width="90">
                    <template #default="{data}">
                        {{data.audit_user_realname || '-'}}
                    </template>
                </c-table-column>
                <c-table-column label="审批时间" width="140">
                    <template #default="{data}">
                        {{data.audit_date || '-'}}
                    </template>
                </c-table-column>
                <c-table-column label="审批备注">
                    <template #default="{data}">
                        {{data.audit_remark || '-'}}
                    </template>
                </c-table-column>
            </c-table>
        </div>
    </c-dialog>
</template>

<script>
    export default {
        name: 'creditRepaymentLog',

        data() {
            return {
                orderId: 0,
                orderNo: '',
                customerName: '',
                productName: ''
            }
        },

        methods: {
            /*********打开弹框（授信账单行数据带入）**********/
            open(data) {
                this.orderId = data.order_id;
                this.orderNo = data.order_no || '';
                this.customerName = data.customer_name || '';
                this.productName = data.product_name || '';
                this.$refs.dialog.open({title: '还款审批记录'});
                this.$nextTick(() => {
                    this.loadList();
                });
            },

            /*********加载该账单历次还款审批记录**********/
            loadList() {
                this.$refs.list.load({
                    url: '/order/credit/repayment/log/list',
                    data: {
                        order_id: this.orderId
                    }
                });
            },

            /*********打开还款单详情（审核完成后刷新审批记录列表）**********/
            creditRepaymentDetail(data) {
                this.globalDialog('creditRepaymentDetail', {
                    props: {
                        id: data.id
                    }
                }, () => {
                    this.loadList();
                });
            },

            /*********格式化价格**********/
            formatPrice(price) {
                if (price === null || price === undefined || price === '') return '-';
                return '¥' + parseFloat(price).toFixed(2);
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .m-log-content {
        padding: 20px;
    }

    .m-log-head {
        padding: 10px 0 16px;
        font-size: 18px;
        font-weight: 600;
        color: #333;
        text-align: center;

        /*客户/商品单独一行展示，不与订单号挤在同一行*/
        .m-log-code {
            display: block;
            margin-top: 8px;
            line-height: 1.4;
            font-size: 14px;
            font-weight: normal;
            color: #666;
        }
    }
</style>
